export const getPercentageRangeIndex = percantage => {
  if (percantage >= 81 && percantage <= 100) {
    return 0;
  }
  if (percantage >= 61 && percantage < 81) {
    return 1;
  }
  if (percantage >= 41 && percantage < 61) {
    return 2;
  }
  if (percantage >= 21 && percantage < 41) {
    return 3;
  }
  if (percantage >= 0 && percantage < 21) {
    return 4;
  }
};
